// extracted by mini-css-extract-plugin
var _1 = "yChMKknu";
var _2 = "ebKlFu_v";
var _3 = "nbbI1q7D";
export { _1 as "confirmBtn", _2 as "pasteList", _3 as "textarea" }
